export const DEFAULT_FLAGS: Record<string, boolean> = { g: true, i: false, m: false, s: false, u: false };

/** Text shown for a match; zero-length matches are labelled instead of blank. */
export function matchLabel(match: string): string {
  return match === "" ? "(empty match)" : match;
}

/** The flag string that is actually passed to RegExp, e.g. "gi" (always in the same order). */
export function flagString(on: Record<string, boolean>): string {
  return ["g", "i", "m", "s", "u"].filter(k => on[k]).join("");
}
